import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { QuestionCompact } from '@ratehub/base-ui';

import { MORTGAGE_RATE_TYPES, MORTGAGE_EXTENDED_RATE_TYPES } from '../definitions/MortgageRateTypes';
import RATE_TYPE_MESSAGES from '../definitions/RateTypeMessages';


function QuestionRateType({ name, value, areOptionsExtended, ...otherProps }) {
    return (
        <QuestionCompact
            field={{
                name: name,
                type: 'choice',
                value: value,
                options: Object.values(areOptionsExtended 
                    ? MORTGAGE_EXTENDED_RATE_TYPES 
                    : MORTGAGE_RATE_TYPES),
            }}
            renderOptionLabel={type => (
                <FormattedMessage
                    {...RATE_TYPE_MESSAGES[type]}
                />
            )}
            labelMessage={(
                <FormattedMessage
                    id="web-components.mortgageRateTableV2+Filter.typeLabel"
                    defaultMessage="Rate type"
                />
            )}
            type="dropdown"
            {...otherProps}
        />
    );
}

QuestionRateType.propTypes = {
    name: PropTypes.string,
    value: PropTypes.oneOf(
        Object.values(MORTGAGE_EXTENDED_RATE_TYPES),
    ),
    areOptionsExtended: PropTypes.bool,
};

QuestionRateType.defaultProps = {
    name: 'type',
    value: undefined,
    areOptionsExtended: false,
};

export default QuestionRateType;